import * as _EnvironmentUtils from "./env"
import * as FetchUtils from "./fetch"
import { WSClient as _WSClient } from "./websocket"
import { InfaceSDK as _InfaceSDK } from "./inface_sdk"
import { SDKError as _SDKError } from "./inface_sdk/sdk_error"
import _lodash from "lodash"
import { BRIDGE_ERRORS } from "./constant/bridge-erros.enum"
import { STATUS_TYPES } from "./constant/status.enum"
import { getModuleApi as _getModuleApi } from "./inface_sdk/get-module-api"
import * as _ConfigUtils from "./config"

import {
  loadModulePath as _loadModulePath,
  requireNative as _requireNative,
  loadModulePath_x86_64 as _loadModulePath_x86_64,
  loadModulePath_i686 as _loadModulePath_i686,
  loadModulePathEX as _loadModulePathEX,
  generateUUID as _generateUUID,
  httpHook as httpHookInstance,
  ITC as _itc,
  TestHelper as _TestHelper,
  IPC as _ipc,
  iconv as _iconv,
  urlencode as _urlencode
} from "./utils"

export const iconv = _iconv
export const urlencode = _urlencode
export const InfaceEnv = _EnvironmentUtils
export const Fetch = FetchUtils.Fetch
export const WSClient = _WSClient
export const InfaceSDK = _InfaceSDK
export const lodash = _lodash
export const loadModulePath = _loadModulePath
export const requireNative = _requireNative
export const loadModulePathEX = _loadModulePathEX
export const loadModulePath_x86_64 = _loadModulePath_x86_64
export const loadModulePath_i686 = _loadModulePath_i686
export const generateUUID = _generateUUID
export const SDKError = _SDKError
export const getModuleApi = _getModuleApi
export const InfaceConfig = _ConfigUtils
export const httpHook = httpHookInstance
export const ITC = _itc
export const TestHelper = _TestHelper
export const IPC = _ipc

const exportModule = {
  iconv,
  urlencode,
  InfaceEnv,
  WSClient,
  ...FetchUtils,
  InfaceSDK,
  lodash: _lodash,
  getModuleApi,
  loadModulePath: _loadModulePath,
  loadModulePath_x86_64,
  loadModulePath_i686,
  requireNative: _requireNative,
  loadModulePathEX,
  generateUUID,
  httpHook,
  ITC,
  SDKError,
  Enum: {
    STATUS_TYPES,
    BRIDGE_ERRORS,
  },
  InfaceConfig,
  TestHelper,
  IPC,
}

export default exportModule
